import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPiechartFilled = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M4.94319 1.48761C5.43392 1.18532 6.04959 1.45848 6.24234 2.00166L8.07809 7.17514C8.22963 7.60223 8.54072 7.95402 8.94605 8.15668L13.888 10.6277C14.403 10.8852 14.599 11.5286 14.2404 11.9791C12.9372 13.616 10.9268 14.6665 8.67019 14.6665C4.74014 14.6665 1.5542 11.4806 1.5542 7.5505C1.5542 4.98621 2.91028 2.73989 4.94319 1.48761Z",
		fill: "#2563EB"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.48823 1.83953C8.07474 1.8525 7.82727 2.27533 7.96561 2.6652L9.39953 6.70624C9.42984 6.79166 9.49205 6.86201 9.57312 6.90255L13.5068 8.86937C13.8401 9.03606 14.2453 8.86116 14.3065 8.49346C14.3575 8.18653 14.384 7.8715 14.384 7.55051C14.384 4.39485 11.8258 1.83668 8.67018 1.83668C8.60932 1.83668 8.54866 1.83764 8.48823 1.83953Z",
		fill: "#2563EB"
	})]
});
const ForwardRef = forwardRef(SvgPiechartFilled);
export default ForwardRef;
